export default __webpack_public_path__ + "static/media/regulatory--no-tricycles--g1.fa034d03.png";